<div class="skeleton-wrapper">
  <div class="skeleton">
    @for (row of numberOfRows; track index; let index = $index) {
      <div class="skeleton__row">
        <div class="skeleton__checkbox"></div>
        @for (col of numberOfCols; track index2; let index2 = $index) {
          <div class="skeleton__cell"></div>
        }
      </div>
    }
  </div>
</div>
